
const required = name => value =>
  value || typeof value === "number" ? undefined : name;
const email = value => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "VALIDATION.EMAIL_NVALID" : undefined);
const number = name => value => (value && Number.isNaN(Number(value)) ? `${name}` : undefined);
const passwordsMatch = (value, allValues) =>
    (value !== allValues.password ? "Password does not match" : undefined);
export { required, email, number, passwordsMatch};